/**
 * @class NumericConstants A collection of numeric constant values
 */
export class NumericConstants {
  static maxDigitalMediaSearchResults: number = 100;
  static maxCriteriaForAFirestoreInClause: number = 30;
}